import { render, staticRenderFns } from "./GlobalComplaint.vue?vue&type=template&id=6ac3d8b1&scoped=true&"
import script from "./GlobalComplaint.vue?vue&type=script&lang=js&"
export * from "./GlobalComplaint.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/complaint.css?vue&type=style&index=0&id=6ac3d8b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3d8b1",
  null
  
)

export default component.exports